import React from "react";
import UserwalkthroughType from "../types/generic/UserWalkthroughType";
import OverrideNavItem from "../types/nav/OverrideNavItem";
import { IconDefinition } from "@fortawesome/fontawesome-common-types";

export interface AppContextInterface {
  pageTitle: string;
  setPageTitle(newTitle: string): void;
  pageIcon: IconDefinition | undefined;
  setPageIcon(newIcon: IconDefinition | undefined): void;
  showPageTitleAccent: boolean;
  setShowPageTitleAccent(value: boolean): void;
  /**
   * When false, #top-bar title drops vertical margins (flush chrome under the bar).
   * Analytics pages turn this off so the filter band sits tight under the header.
   * Default true.
   */
  showTopBarTitleSpacing: boolean;
  setShowTopBarTitleSpacing(value: boolean): void;
  overrideNavItem: OverrideNavItem | null;
  setOverrideNavItem(newItem: OverrideNavItem | null): void;
  activeDashboardTypeForWalkthrough: UserwalkthroughType | null;
  setActiveDashboardTypeForWalkthrough(
    dashboardType: UserwalkthroughType | null
  ): void;
  sideBarIsOpen: boolean;
  setSideBarIsOpen(isSideBarOpen: boolean): void;
  /**
   * The user has chosen to hide the AccessiBe widget on this browser. Shared so the
   * profile menu can label its toggle while the plugin owns applying it to the page.
   */
  accessibilityToolHidden: boolean;
  setAccessibilityToolHidden(isHidden: boolean): void;
}

const AppContext = React.createContext<AppContextInterface>({
  pageTitle: "",
  setPageTitle(newTitle: string) {},
  pageIcon: undefined,
  setPageIcon(newIcon: IconDefinition | undefined) {},
  showPageTitleAccent: true,
  setShowPageTitleAccent(value: boolean) {},
  showTopBarTitleSpacing: true,
  setShowTopBarTitleSpacing(value: boolean) {},
  overrideNavItem: null,
  setOverrideNavItem(newItem: OverrideNavItem | null) {},
  activeDashboardTypeForWalkthrough: null,
  setActiveDashboardTypeForWalkthrough(value: UserwalkthroughType | null) {},
  sideBarIsOpen: false,
  setSideBarIsOpen(value: boolean) {},
  accessibilityToolHidden: false,
  setAccessibilityToolHidden(value: boolean) {},
});

export default AppContext;
